module.exports = Promise.all([__parcel__import__("hbwOp"), __parcel__import__("4Swnm")]).then(() => parcelRequire('3pHq1'));